import { handlerError } from 'util/handlerError'
import { SagaIterator } from 'redux-saga'
import { call, fork, put, all, takeEvery } from 'redux-saga/effects'
import { TYPES } from './types'
import * as atendimentoActions from 'store/modules/atendimento/actions'
import * as inicioController from 'controller/inicioController'
import * as inicioActions from 'store/modules/inicio/actions'
import * as loadingActions from 'store/modules/loading/actions'
import * as loginActions from 'store/modules/login/actions'
import { removeMaskCPF } from 'util/masks'
import { Telefone } from 'models/types'
import moment from 'moment'
import history from 'util/history'
import { InfosChamada } from 'models/atendimento/types'

interface GenericProps {
  type: string
  id: string
}

function* getQuantidadeLeads(): SagaIterator {
  try {
    const response = yield call(inicioController.getQuantidadeLeads)
    yield put(
      inicioActions.setQuantidadeLeads(response?.data?.content?.quantidade || 0)
    )
  } catch (error) {
    handlerError(error)
  }
}

function* iniciarAtendimentoLead(): SagaIterator {
  try {
    yield put(loadingActions.setLoading(true))
    const response = yield call(inicioController.iniciarAtendimentoLead)
    if (response?.data?.content?.atendimentoDiscadorAtivo) {
      return yield put(loginActions.verificaAtendimentoAtivoSaga())
    }
    yield put(
      atendimentoActions.startAtendimento(response?.data?.content?.cpfCnpj, 1)
    )
    const telefones: InfosChamada['telefones'] = []
    response?.data?.content?.telefones.forEach((telefone: Telefone) => {
      telefones.push({
        numero: `(${telefone.ddd}) ${telefone.numero}`,
        whatsapp: telefone.whatsapp,
        telefoneId: telefone.telefoneId
      })
    })
    yield put(
      atendimentoActions.setInfosContato(
        {
          nome: response?.data?.content?.nome,
          dataNascimento: moment(
            response?.data?.content?.dataNascimento
          ).format('DD/MM/YYYY'),
          cidade: response?.data?.content?.cidade,
          sexo: response?.data?.content?.sexo,
          clienteRiber: response?.data?.content?.clienteRiber,
          infosChamada: {
            telefones: telefones,
            dataAgendamento: moment().add(1, 'days').format('YYYY-MM-DD'),
            horarioAgendamento: moment().format('HH:mm'),
            numeroChamada: [],
            observacoesAgendamento: '',
            tabulacaoChamada: null,
            tipoAgendamento: '',
            emChamada: false,
            infosMatriculasLead: []
          },
          atendimentoId: response?.data?.content?.atendimentoId,
          tipoProduto: response?.data?.content?.tipoProduto,
          campanhaCrmId: response?.data?.content?.campanhaCrmId,
          atendimentoAgendadoId: response?.data?.content?.atendimentoAgendadoId,
          consultorId: null,
          tipoAtendimento: 3,
          integracaoUrl: '',
          clienteSite: response?.data?.content?.clienteSite
        },
        response?.data?.content?.cpfCnpj
      )
    )

    if (window.location.pathname.toLowerCase() !== '/atendimento') {
      history.push('/atendimento')
    }
    yield put(
      atendimentoActions.setModalAtendimentoAgendado(
        !!response?.data?.content?.atendimentoAgendadoId,
        removeMaskCPF(response?.data?.content?.cpfCnpj)
      )
    )
  } catch (error) {
    handlerError(error, 'Não foi possível iniciar o atendimento da Lead!')
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

interface IniciarAtendimentoCarteirasProps extends GenericProps {
  tipoProduto: number
  consultorId: string
}

function* iniciarAtendimentoCarteiras({
  tipoProduto,
  consultorId
}: IniciarAtendimentoCarteirasProps): SagaIterator {
  try {
    yield put(loadingActions.setLoading(true))
    const response = yield call(
      inicioController.iniciarAtendimentoCarteiras,
      tipoProduto,
      consultorId
    )
    if (response?.data?.content?.atendimentoDiscadorAtivo) {
      return yield put(loginActions.verificaAtendimentoAtivoSaga())
    }
    yield put(
      atendimentoActions.startAtendimento(response?.data?.content?.cpfCnpj, 1)
    )
    const telefones: InfosChamada['telefones'] = []
    response?.data?.content?.telefones.forEach((telefone: Telefone) => {
      telefones.push({
        numero: `(${telefone.ddd}) ${telefone.numero}`,
        whatsapp: telefone.whatsapp,
        telefoneId: telefone.telefoneId
      })
    })
    yield put(
      atendimentoActions.setInfosContato(
        {
          nome: response?.data?.content?.nome,
          dataNascimento: moment(
            response?.data?.content?.dataNascimento
          ).format('DD/MM/YYYY'),
          cidade: response?.data?.content?.cidade,
          sexo: response?.data?.content?.sexo,
          clienteRiber: response?.data?.content?.clienteRiber,
          infosChamada: {
            telefones: telefones,
            dataAgendamento: moment().add(1, 'days').format('YYYY-MM-DD'),
            horarioAgendamento: moment().format('HH:mm'),
            numeroChamada: [],
            observacoesAgendamento: '',
            tabulacaoChamada: null,
            tipoAgendamento: '',
            emChamada: false,
            infosMatriculasLead: []
          },
          atendimentoId: response?.data?.content?.atendimentoId,
          tipoProduto: response?.data?.content?.tipoProduto,
          campanhaCrmId: response?.data?.content?.campanhaCrmId,
          atendimentoAgendadoId: response?.data?.content?.atendimentoAgendadoId,
          consultorId: consultorId,
          tipoAtendimento: 1,
          integracaoUrl: '',
          clienteSite: response?.data?.content?.clienteSite
        },
        response?.data?.content?.cpfCnpj
      )
    )
    if (window.location.pathname.toLowerCase() !== '/atendimento') {
      history.push('/atendimento')
    }
    yield put(
      atendimentoActions.setModalAtendimentoAgendado(
        !!response?.data?.content?.atendimentoAgendadoId,
        removeMaskCPF(response?.data?.content?.cpfCnpj)
      )
    )
  } catch (error) {
    handlerError(error, 'Não foi possível iniciar o atendimento da Carteira!')
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

function* getCampanhas(): SagaIterator {
  try {
    yield put(inicioActions.setLoading('campanhas', true))
    const response = yield call(inicioController.getCampanhas)
    yield put(inicioActions.setCampanhas(response?.data?.content))
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(inicioActions.setLoading('campanhas', false))
  }
}

interface IniciarAtendimentoCampanhasProps extends GenericProps {
  campanhaCrmId: string
}

function* iniciarAtendimentoCampanhas({
  campanhaCrmId
}: IniciarAtendimentoCampanhasProps): SagaIterator {
  try {
    yield put(loadingActions.setLoading(true))
    const response = yield call(
      inicioController.iniciarAtendimentoCampanhas,
      campanhaCrmId
    )
    if (response?.data?.content?.atendimentoDiscadorAtivo) {
      return yield put(loginActions.verificaAtendimentoAtivoSaga())
    }
    yield put(
      atendimentoActions.startAtendimento(response?.data?.content?.cpfCnpj, 1)
    )
    const telefones: InfosChamada['telefones'] = []
    response?.data?.content?.telefones.forEach((telefone: Telefone) => {
      telefones.push({
        numero: `(${telefone.ddd}) ${telefone.numero}`,
        whatsapp: telefone.whatsapp,
        telefoneId: telefone.telefoneId
      })
    })
    yield put(
      atendimentoActions.setInfosContato(
        {
          nome: response?.data?.content?.nome,
          dataNascimento: moment(
            response?.data?.content?.dataNascimento
          ).format('DD/MM/YYYY'),
          cidade: response?.data?.content?.cidade,
          sexo: response?.data?.content?.sexo,
          clienteRiber: response?.data?.content?.clienteRiber,
          infosChamada: {
            telefones: telefones,
            dataAgendamento: moment().add(1, 'days').format('YYYY-MM-DD'),
            horarioAgendamento: moment().format('HH:mm'),
            numeroChamada: [],
            observacoesAgendamento: '',
            tabulacaoChamada: null,
            tipoAgendamento: '',
            emChamada: false,
            infosMatriculasLead: []
          },
          atendimentoId: response?.data?.content?.atendimentoId,
          tipoProduto: response?.data?.content?.tipoProduto,
          campanhaCrmId: response?.data?.content?.campanhaCrmId,
          atendimentoAgendadoId: response?.data?.content?.atendimentoAgendadoId,
          consultorId: null,
          tipoAtendimento: 2,
          integracaoUrl: '',
          clienteSite: response?.data?.content?.clienteSite
        },
        response?.data?.content?.cpfCnpj
      )
    )
    if (window.location.pathname.toLowerCase() !== '/atendimento') {
      history.push('/atendimento')
    }
    yield put(
      atendimentoActions.setModalAtendimentoAgendado(
        !!response?.data?.content?.atendimentoAgendadoId,
        removeMaskCPF(response?.data?.content?.cpfCnpj)
      )
    )
  } catch (error) {
    handlerError(error, 'Não foi possível iniciar o atendimento da Campanha!')
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

interface GetBigNumbersProps extends GenericProps {
  data: string
}

function* getBigNumbers({ data }: GetBigNumbersProps): SagaIterator {
  try {
    yield put(inicioActions.setLoading('bigNumbers', true))
    yield put(inicioActions.cleanBigNumbers())
    const response = yield call(inicioController.getBigNumbers, data)
    yield put(inicioActions.setBigNumbers(response?.data?.content))
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(inicioActions.setLoading('bigNumbers', false))
  }
}

function* getCentrosCusto(): SagaIterator {
  try {
    yield put(loadingActions.setLoading(true))

    const response = yield call(inicioController.getCentrosCustosCarteira)
    const centrosCusto = response?.data?.content.map(
      (centroCusto: { id: string; descricao: string }) => {
        return {
          id: centroCusto.id,
          descricao: centroCusto.descricao,
          consultores: []
        }
      }
    )
    yield put(inicioActions.setCentrosCustoCarteira(centrosCusto))
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

interface GetCarteirasProps extends GenericProps {
  consultorId: string
  centroCustoId: string
}
function* getConsultoresCarteiraByCentroCusto({
  centroCustoId
}: GetCarteirasProps): SagaIterator {
  try {
    yield put(loadingActions.setLoading(true))

    const response = yield call(
      inicioController.getConsultoresCarteiraByCentroCusto,
      centroCustoId
    )
    const consultores = response?.data?.content.map(
      (consultor: { id: string; nome: string }) => {
        return {
          id: consultor.id,
          nome: consultor.nome,
          carteirasConsultor: []
        }
      }
    )
    yield put(
      inicioActions.setConsultoresCarteiraByCentroCusto(
        consultores,
        centroCustoId
      )
    )
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

function* getCarteiraByConsultor({
  centroCustoId,
  consultorId
}: GetCarteirasProps): SagaIterator {
  try {
    yield put(loadingActions.setLoading(true))

    const response = yield call(
      inicioController.getCarteiraByConsultor,
      consultorId,
      centroCustoId
    )
    yield put(
      inicioActions.setCarteirasByConsultor(
        response?.data?.content,
        centroCustoId,
        consultorId
      )
    )
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

interface AlternarStatusCampanhaProps extends GenericProps {
  codigoCampanhaDiscador: string
  started: boolean
}
function* alternarStatusCampanha({
  codigoCampanhaDiscador,
  started
}: AlternarStatusCampanhaProps): SagaIterator {
  try {
    yield put(loadingActions.setLoading(true))

    if (!started) {
      yield call(inicioController.ativarCampanha, codigoCampanhaDiscador)
    } else {
      yield call(inicioController.desativarCampanha, codigoCampanhaDiscador)
    }
    yield put(inicioActions.getCampanhasSaga())
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

function* watchIniciarAtendimentoLead() {
  yield takeEvery(TYPES.INICIAR_ATENDIENTO_LEAD_SAGA, iniciarAtendimentoLead)
}

function* watchGetQuantidadeLeads() {
  yield takeEvery(TYPES.GET_QUANTIDADE_LEADS_SAGA, getQuantidadeLeads)
}

function* watchIniciarAtendimentoCarteiras() {
  yield takeEvery(
    TYPES.INICIAR_ATENDIMENTO_CARTEIRAS_SAGA,
    iniciarAtendimentoCarteiras
  )
}

function* watchGetCampanhas() {
  yield takeEvery(TYPES.GET_CAMPANHAS_SAGA, getCampanhas)
}

function* watchIniciarAtendimentoCampanhas() {
  yield takeEvery(
    TYPES.INICIAR_ATENDIMENTO_CAMPANHAS_SAGA,
    iniciarAtendimentoCampanhas
  )
}

function* watchGetBigNumbers() {
  yield takeEvery(TYPES.GET_BIGNUMBERS_SAGA, getBigNumbers)
}

function* watchAlternarStatusCampanha() {
  yield takeEvery(TYPES.ALTERNAR_STATUS_CAMPANHA_SAGA, alternarStatusCampanha)
}

function* watchGetCentrosCusto() {
  yield takeEvery(TYPES.GET_CENTROS_CUSTO_SAGA, getCentrosCusto)
}

function* watchGetConsultoresCarteiraByCentroCusto() {
  yield takeEvery(
    TYPES.GET_CONSULTORES_CARTEIRA_BY_CENTRO_CUSTO_SAGA,
    getConsultoresCarteiraByCentroCusto
  )
}

function* watchGetCarteirasByConsultor() {
  yield takeEvery(TYPES.GET_CARTEIRAS_BY_CONSULTOR_SAGA, getCarteiraByConsultor)
}

function* inicioSaga() {
  yield all([
    fork(watchGetQuantidadeLeads),
    fork(watchIniciarAtendimentoLead),
    fork(watchIniciarAtendimentoCarteiras),
    fork(watchGetCampanhas),
    fork(watchIniciarAtendimentoCampanhas),
    fork(watchGetBigNumbers),
    fork(watchAlternarStatusCampanha),
    fork(watchGetCentrosCusto),
    fork(watchGetConsultoresCarteiraByCentroCusto),
    fork(watchGetCarteirasByConsultor)
  ])
}

export default inicioSaga
